/**
 * Plaid onboarding (Clerk JWT before UserProfile). Uses Bearer from {@link getClerkToken} via apiTransport.
 */

import type { TrustAccountingPlaidData } from './auth';
import { apiTransport } from './transport';

export type PlaidLinkTokenResponse = { link_token: string; expiration?: string };

export type PlaidExchangeResponse = {
  stripe_bank_account_token: string;
  institutionName: string | null;
};

export const onboardingPlaidApi = {
  createLinkToken: (): Promise<PlaidLinkTokenResponse> =>
    apiTransport.post<PlaidLinkTokenResponse>('/plaid/create-link-token', {}),

  exchangePublicToken: (body: { publicToken: string; accountId: string }): Promise<PlaidExchangeResponse> =>
    apiTransport.post<PlaidExchangeResponse>('/plaid/exchange-public-token', body),
};

export function trustAccountingPlaidFromExchange(out: PlaidExchangeResponse): TrustAccountingPlaidData {
  return {
    operating: {
      processorToken: out.stripe_bank_account_token,
      ...(out.institutionName ? { bankName: out.institutionName } : {}),
    },
  };
}
